import React, { useState } from 'react';
import logoImg from '../../assets/images/nav-logo.png';
import { FaUserCircle, FaChevronDown, FaUser, FaSignOutAlt, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';


const AdminNavbar = ({ setIsMobileMenuOpen }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();

    const storedAdminStr = localStorage.getItem('user');
    const storedAdmin = storedAdminStr ? JSON.parse(storedAdminStr) : null;
    const adminName = localStorage.getItem('username') || (storedAdmin ? storedAdmin.name : 'Admin');
    const adminemail = storedAdmin ? (storedAdmin.emailid || storedAdmin.email) : 'No Email';
    

    const handleLogout = () => {
        localStorage.clear();
        navigate('/TGSH/login');

    };

    const handleProfileClick = () => {
        setShowDropdown(false)
        navigate('/TGSH/admin/profile')
    };
    return (
        <header 
            className="fixed top-0 left-0 w-full flex justify-between items-center z-[2000]"
            style={{ 
                backgroundColor: '#64a106', 
                height: '64px',
                margin: '0',
                padding: '0',
                border: 'none'
            }}
        >
            {/* 1. Left Section */}
            <div className="h-full flex items-center gap-2 md:gap-4 w-auto md:w-64 px-3 md:px-5 flex-shrink-0" style={{ backgroundColor: '#64a106' }}>
                <button
                className="md:hidden text-white text-xl"
                // onClick={() => setIsMobileMenuOpen(true)}
                onClick={() => {
                    setIsMobileMenuOpen(prev => !prev);
                }}
                >
                <FaBars />
                </button>
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center overflow-hidden">
                    {/* Fixed src: removed quotes from logoImg */}
                    <img src={logoImg} alt="TGSH Logo" className="w-full h-full object-contain" />
                </div>
                <span className="hidden sm:block font-bold tracking-[1px] uppercase text-[13px] text-white">
                    ADMIN PANEL
                </span>
            </div>

            {/* 2. Middle Section */}
            <div className="flex-1 hidden md:flex items-center h-full px-6" style={{ backgroundColor: '#64a106' }}>
                <h1 className="m-0 font-bold uppercase tracking-[1px] text-white text-[13px]">
                    THE GLOBAL SCHOOL OF HAPPINESS
                </h1>
            </div>
            
            {/* 3. Right Section (Profile Dropdown) */}
            <div className="flex items-center px-6 h-full" style={{ backgroundColor: '#64a106' }}>
                <div className="relative h-full flex items-center">
                    <button 
                        onClick={() => setShowDropdown(!showDropdown)}
                        className="flex items-center gap-2 bg-transparent border-none cursor-pointer text-white hover:bg-black/10 px-3 h-full transition-all outline-none"
                    >
                        <div className="text-right hidden md:block">
                            <p className="m-0 text-[11px] font-bold uppercase leading-tight">{adminName}</p>
                            <p className="m-0 text-[9px] text-white/80 lowercase leading-tight">{adminemail}</p>
                        </div>
                        <FaUserCircle className="text-xl" />
                        <FaChevronDown className={`text-[9px] transition-transform ${showDropdown ? 'rotate-180' : ''}`} />
                    </button>

                    {showDropdown && (
                        <div className="absolute right-0 top-[64px] w-48 bg-white shadow-2xl rounded-lg py-1 border border-gray-100 z-[5000]">
                            <div className="px-4 py-2 border-b border-gray-50">
                                <p className="text-xs font-bold text-gray-800">Hello, {adminName}</p>
                            </div>
                            
                            <button 
                                onClick={handleProfileClick} 
                                className="w-full text-left px-4 py-2 hover:bg-gray-50 text-xs text-gray-600 flex items-center gap-3 border-none bg-white cursor-pointer transition-colors"
                            >
                                <FaUser className="text-blue-900" /> View Profile
                            </button>

                            <div className="h-[1px] bg-gray-50 my-1"></div>
                            
                            <button 
                                onClick={handleLogout} 
                                className="w-full text-left px-4 py-2 hover:bg-red-50 text-xs text-red-500 font-bold flex items-center gap-3 border-none bg-white cursor-pointer transition-colors"
                            >
                                <FaSignOutAlt /> Log Out
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default AdminNavbar;